import { IDocumentImageSource, ImageSourceKinds } from "../../../../domain/document";
import { SignExecuteRequest, SignExecuteResult } from "../../../../domain/localhost/items";
import { ImageSource } from "../../../document/ver2";
import { ISignExecuteRequestBean, ISignExecuteResultBean } from "../beans";

export class SignParameterTranslator {
  public static toSignExecuteResult(bean: ISignExecuteResultBean, _getToken: () => string): SignExecuteResult {
    if (!bean) { return null; }
    const result = new SignExecuteResult();
    result.isComplete = bean.isComplete;
    result.imageSource = this.createImageSource(bean.cacheGuid, _getToken);
    result.signatureCacheGuid = bean.signatureCacheGuid;
    return result;
  }

  private static createImageSource(cacheGuid: string, getToken: () => string): IDocumentImageSource {
    if (!cacheGuid || cacheGuid === "") { return null; }
    return new ImageSource(getToken, null, null, ImageSourceKinds.Cache, cacheGuid);
  }

  public static toSignExecuteRequestBean(request: SignExecuteRequest): ISignExecuteRequestBean {
    if (!request) { return null; }
    if (!(request instanceof SignExecuteRequest)) { throw new Error("invalid request!!!"); }
    return {
      width: request.width,
      height: request.height,
    };
  }
}
